import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const DebiaResultMob = () => {
  return <CommonResult />;
};

export default DebiaResultMob;
